import { DoubleBounce } from '@components/ui';
import clsx from 'clsx';

type Props = {
  text?: string;
  className?: string;
};

export const LoadingScreen = ({ text = 'Loading...', className }: Props) => {
  return (
    <div
      className={clsx('flex h-screen items-center justify-center', className)}
    >
      <div className="text-center text-secondary">
        <DoubleBounce size={100} />
        <div className="mt-2 text-xl text-primary">{text}</div>
      </div>
    </div>
  );
};
